import React, { useRef, useEffect } from "react";

function useOutsideClickCallback(ref, callback) {
    useEffect(() => {
        if (!ref || !ref.current) return;

        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                // alert("You clicked outside of me!");
                if (callback) callback();
            }
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref.current]);
}

export default useOutsideClickCallback;